(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["navigation-drawer"]) return;
  try {
    
  // Toggle Submenu
  function toggleSubmenu(button) {
    const submenu = button.nextElementSibling;
    const isExpanded = button.getAttribute('aria-expanded') === 'true';

    button.setAttribute('aria-expanded', !isExpanded);
    submenu.setAttribute('aria-expanded', !isExpanded);
  }

  // Make globally available
  window.toggleSubmenu = toggleSubmenu;

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  class ThemeSlideshow extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      this.idx = 0;
      this.slides = Array.from(this.querySelectorAll('.c_e4ce91fb'));
      this.dotsWrap = this.querySelector('.flickity-page-dots');
      this.timer = null;
      this.delay = (parseInt(this.dataset.speed, 10) || 5) * 1000;
      this.auto = this.dataset.autoplay !== 'false';

      /* Initialize slide active states */
      if (this.slides.length > 0) {
        const activeIdx = this.slides.findIndex((s) => s.classList.contains('is-active'));
        this.idx = activeIdx >= 0 ? activeIdx : 0;
        this.slides.forEach((slide, i) => {
          if (i === this.idx) {
            slide.classList.add('is-active');
          } else {
            slide.classList.remove('is-active');
          }
        });
      }

      /* Single delegated listener for all dots */
      if (this.dotsWrap) {
        this.dotsWrap.addEventListener('click', (e) => {
          const dot = e.target.closest('.c_g3125c0e, li[data-index]');
          if (!dot) return;
          const targetIdx = Number(dot.dataset.index);
          if (!isNaN(targetIdx)) {
            this.goTo(targetIdx);
            this.resetTimer();
          }
        });
      }

      if (this.slides.length < 2) return;

      /* Pointer Swipe (Touch + Mouse Drag) */
      let startX = 0;
      let isDragging = false;

      this.addEventListener('pointerdown', (e) => {
        startX = e.clientX;
        isDragging = true;
      });

      this.addEventListener('pointerup', (e) => {
        if (!isDragging) return;
        isDragging = false;
        const dx = e.clientX - startX;
        if (Math.abs(dx) > 40) {
          this.goTo(this.idx + (dx < 0 ? 1 : -1));
          this.resetTimer();
        }
      });

      this.addEventListener('pointercancel', () => {
        isDragging = false;
      });

      /* Autoplay */
      if (this.auto) {
        this.play();
        this.addEventListener('mouseenter', () => this.pause());
        this.addEventListener('mouseleave', () => this.play());
      }
    }

    goTo(next) {
      const len = this.slides.length;
      if (!len) return;
      next = ((next % len) + len) % len;
      if (next === this.idx && this.slides[this.idx]?.classList.contains('is-active')) return;

      const prevIdx = this.idx;
      this.idx = next;

      if (this.slides[prevIdx]) {
        this.slides[prevIdx].classList.remove('is-active');
      }

      const currentSlide = this.slides[next];
      if (currentSlide) {
        currentSlide.classList.remove('is-active');
        void currentSlide.offsetWidth;
        currentSlide.classList.add('is-active');
      }

      if (this.dotsWrap && this.dotsWrap.children) {
        Array.from(this.dotsWrap.children).forEach((dot, i) => {
          if (i === next) {
            dot.classList.add('c_i019dda1');
          } else {
            dot.classList.remove('c_i019dda1');
          }
        });
      }
    }

    play() {
      if (!this.auto) return;
      this.pause();
      this.timer = setInterval(() => this.goTo(this.idx + 1), this.delay);
    }

    pause() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    resetTimer() {
      if (this.auto) {
        this.pause();
        this.play();
      }
    }

    disconnectedCallback() {
      this.pause();
    }
  }

  if (!customElements.get('theme-slideshow')) {
    customElements.define('theme-slideshow', ThemeSlideshow);
  }

  } catch(e) { console.error(e); }
})();
})();
